import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import useI18n from 'hooks/I18n/useI18n';
import { capitalizeFirstLetter } from 'modules/utils/string';
import { getLocalizedDateWithMonthDayWithoutYear } from 'modules/utils/dateAndTime';

import Link, { DISPLAY_MODES } from 'src/components/atoms/Link/Link.jsx';
import HostCard from 'components/Maps/ProductIdentity/AssembliesMap/Modal/HostCard.jsx';
import Text from 'components/ProductIdentity/Text.jsx';
import Button, { SECONDARY_MODE, XSMALL_SIZE } from 'src/components/atoms/Button/Button.jsx';

export const PickupCard = ({ pickupData, selected, onChooseDate }) => {
    const { i18n, trans } = useI18n();
    const [selectedDistributionId, setSelectedDistributionId] = useState(null);

    const hasDistribution = pickupData.pickupDates.length;
    useEffect(() => {
        if (hasDistribution) {
            pickupData.pickupDates.sort((distribA, distribB) => {
                return distribA.timeStart > distribB.timeStart ? 1 : -1;
            });
            setSelectedDistributionId(pickupData.pickupDates?.[0]?.distributionId);
        }
    }, [pickupData, hasDistribution]);

    const pickupAddress = pickupData.meetingPoint.fullAddress;

    const { name, host } = pickupData;

    return (
        <div className={classnames('assemblies-card-container', { selected })}>
            <HostCard
                url={
                    hasDistribution
                        ? `/${i18n}/assemblies/${pickupData.pickupDates[0].assemblyId}`
                        : undefined
                }
                photoUuid={host.photoUuid}
                pointOfSaleName={name}
                street={pickupAddress}
                hostFirstname={host.firstname}
            />

            {hasDistribution ? (
                <div className="assemblies-card-container-distribution-dates">
                    <>
                        <Text
                            size="14px"
                            weight={600}
                            className="assemblies-card-container-distribution-dates-title"
                        >
                            {capitalizeFirstLetter(
                                getLocalizedDateWithMonthDayWithoutYear(
                                    i18n,
                                    moment(pickupData.pickupDates[0].timeStart).toDate()
                                )
                            )}
                        </Text>
                        <ul>
                            <li>
                                {trans('assembliesMap.assembly.timeslot', {
                                    '%startHour%': moment(
                                        pickupData.pickupDates[0].timeStart
                                    ).format('LT'),
                                    '%endHour%': moment(pickupData.pickupDates[0].timeEnd).format(
                                        'LT'
                                    ),
                                })}
                            </li>
                        </ul>
                    </>
                </div>
            ) : (
                <div className="assemblies-card-container-no-distributions">
                    <Text size="12px" lineHeight="18px" color="red4">
                        {trans('distributions.follow.empty.title')}
                    </Text>
                </div>
            )}

            {hasDistribution ? (
                <div className="assemblies-card-container-button">
                    <Link
                        href={`/${i18n}/assemblies/${pickupData.pickupDates[0].assemblyId}/collections/${pickupData.pickupDates[0].distributionId}/products`}
                        className={classnames({ disabled: !selectedDistributionId })}
                        displayMode={DISPLAY_MODES.BUTTON}
                        bypassRouter
                    >
                        <Text>{trans('assembliesMap.modal.goToSaleBtn')}</Text>
                    </Link>
                    {pickupData.pickupDates.length > 1 && (
                        <Button
                            onClick={() => onChooseDate(pickupData)}
                            size={XSMALL_SIZE}
                            mode={SECONDARY_MODE}
                        >
                            <Text>{trans('assembliesMap.button.chooseDate')}</Text>
                        </Button>
                    )}
                </div>
            ) : null}
        </div>
    );
};

PickupCard.propTypes = {
    pickupData: PropTypes.object,
    selected: PropTypes.bool,
    onChooseDate: PropTypes.func,
};
PickupCard.defaultProps = {
    onChooseDate: () => null,
};

export default React.memo(PickupCard);
